import {
    COLOR_BLACK,
    COLOR_WHITE,
    COLOR_RED,
    COLOR_GREEN,
    COLOR_YELLOW,
    COLOR_STRONG_YELLOW,
    COLOR_TRANSP_YELLOW_HIGHLIGHT,
    COLOR_VIOLET_DARKEST,
    COLOR_VIOLET_DARKER,
    COLOR_VIOLET_PRIMARY,
    COLOR_DEEP_BLUE,
    COLOR_BLUE_LINK,
    COLOR_BLUE_PRIMARY,
    COLOR_BLUE_NEON,
    COLOR_BLUE_NEON_LUMINATING,
    COLOR_GREY_TEXT,
    COLOR_GREY_DARKER,
    COLOR_GREY_LIGHT,
    COLOR_GREY_BACKGROUND,
    COLOR_TRANSP_VIOLET,
    COLOR_TRANSP_GREY_LIGHT,
    COLOR_GREY_LIGHTER,
    COLOR_ICON_BACKGROUND,
    COLOR_TRANSP_BLUE_DARKER,
    COLOR_TRANSP_BLUE_DISABLED,
    COLOR_TRANSP_BLUE,
    COLOR_PRIMARY,
    COLOR_GREEN_TRANSPARENT,
    COLOR_RED_TRANSPARENT,
    COLOR_RED_DEEP,
    COLOR_TAB_WHITE,
    COLOR_TEXT_HEADING,
    COLOR_TEXT_MUTED_PURPLE,
    COLOR_TEXT_SUBTLE_PURPLE,
    COLOR_SURFACE_ELEVATED,
    COLOR_SURFACE_PAGE,
    COLOR_SURFACE_ALT,
    COLOR_BORDER_SUBTLE,
    COLOR_ERROR_BG,
    COLOR_ERROR_TEXT_DARK,
    COLOR_INDIGO_PRIMARY,
    COLOR_TEAL_ACCENT,
    COLOR_TREE_NODE_BG,
    COLOR_TREE_NODE_ACCENT,
} from './constants'

const colors = {
    primary: COLOR_PRIMARY,
    black: COLOR_BLACK,
    white: COLOR_WHITE,
    red: COLOR_RED,
    red_transparent: COLOR_RED_TRANSPARENT,
    deep_red: COLOR_RED_DEEP,
    green: COLOR_GREEN,
    green_transparent: COLOR_GREEN_TRANSPARENT,
    yellow: COLOR_YELLOW,
    strong_yellow: COLOR_STRONG_YELLOW,
    transp_yellow_hightlight: COLOR_TRANSP_YELLOW_HIGHLIGHT,
    violet_darkest: COLOR_VIOLET_DARKEST,
    violet_darker: COLOR_VIOLET_DARKER,
    violet_primary: COLOR_VIOLET_PRIMARY,
    deep_blue: COLOR_DEEP_BLUE,
    tab_white: COLOR_TAB_WHITE,
    blue_link: COLOR_BLUE_LINK,
    blue_primary: COLOR_BLUE_PRIMARY,
    blue_neon: COLOR_BLUE_NEON,
    blue_neon_luminating: COLOR_BLUE_NEON_LUMINATING,
    grey_text: COLOR_GREY_TEXT,
    grey_darker: COLOR_GREY_DARKER,
    grey_light: COLOR_GREY_LIGHT,
    grey_background: COLOR_GREY_BACKGROUND,
    transp_violet: COLOR_TRANSP_VIOLET,
    transp_grey_light: COLOR_TRANSP_GREY_LIGHT,
    grey_lighter: COLOR_GREY_LIGHTER,
    icon_background: COLOR_ICON_BACKGROUND,
    transp_blue_darker: COLOR_TRANSP_BLUE_DARKER,
    transp_blue_disabled: COLOR_TRANSP_BLUE_DISABLED,
    transp_blue: COLOR_TRANSP_BLUE,
    // Semantic tokens
    text_heading: COLOR_TEXT_HEADING,
    text_muted_purple: COLOR_TEXT_MUTED_PURPLE,
    text_subtle_purple: COLOR_TEXT_SUBTLE_PURPLE,
    surface_elevated: COLOR_SURFACE_ELEVATED,
    surface_page: COLOR_SURFACE_PAGE,
    surface_alt: COLOR_SURFACE_ALT,
    border_subtle: COLOR_BORDER_SUBTLE,
    error_bg: COLOR_ERROR_BG,
    error_text_dark: COLOR_ERROR_TEXT_DARK,
    indigo_primary: COLOR_INDIGO_PRIMARY,
    teal_accent: COLOR_TEAL_ACCENT,
    tree_node_bg: COLOR_TREE_NODE_BG,
    tree_node_accent: COLOR_TREE_NODE_ACCENT,
}

export default colors;
